<!-- eslint-disable max-len -->
<template>
  <div>
    <div class="relative pt-1 custome-progress">
      <div class="overflow-hidden h-1 mb-4 text-xs flex rounded bg-green-200">
        <div
          class="
            w-2/4
            shadow-none
            flex flex-col
            text-center
            whitespace-nowrap
            text-white
            justify-center
            bg-green-500
          "
        ></div>
      </div>
    </div>

    <LoadingSpinner v-if="loading" />

    <div v-if="!loading" class="sign_confirm_block">
      <div class="body_inner">
        <h4>
          {{
            registrationState
              ? $t("pages.phone_check.signup.heading")
              : $t("pages.phone_check.login.heading")
          }}
        </h4>
        <p v-if="registrationState">
          {{ $t("pages.phone_check.signup.sub_heading") }}
        </p>
        <vue-tel-input
          v-on:country-changed="countryChanged"
          v-model="cell"
          v-bind="bindProps"
          :autoFormat="false"
          :valid-characters-only="true"
          
          @input="acceptNumber"
        >
          <template slot="arrow-icon">
            <span class="vti__dropdown-arrow">&nbsp;▼</span>
          </template>
        </vue-tel-input>
        <br />
        <div class="ds_form_block">
       

          <div class="action_block">
            <div class="form-group">
              <button
                :class="{ 'disabled:opacity-50': cell.length < 9 }"
                class="
                  w-full
                  flex
                  items-center
                  justify-center
                  btn_apply
                  rounded-lg
                  text-white
                  btn_action
                "
                :disabled="cell.length < 9"
                @click="submit"
              >
                {{ $t("pages.common.buttons.continue") }}
              </button>
            </div>
          </div>
          <!-- Start -->
          <div v-if="false" class="social_signup_block">
            <div class="w-full or_option">
              <span> {{ $t("pages.common.or") }} </span>
            </div>
            <div class="form-group">
              <button
                class="
                  flex
                  items-center
                  justify-start
                  rounded-lg
                  w-full
                  btn_facebook
                "
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 0C4.486 0 0 4.486 0 10C0 15.003 3.697 19.1475 8.5 19.875V12.5H6.5C6.224 12.5 6 12.2765 6 12V10.5C6 10.2235 6.224 10 6.5 10H8.5V8.184C8.5 5.8085 9.7135 4.5 11.917 4.5C12.81 4.5 13.5145 4.562 13.544 4.5645C13.802 4.5875 14 4.8035 14 5.0625V6.75C14 7.0265 13.776 7.25 13.5 7.25H12.5C11.9485 7.25 11.5 7.6985 11.5 8.25V10H13.5C13.6435 10 13.78 10.0615 13.875 10.169C13.97 10.277 14.014 10.42 13.9965 10.562L13.809 12.062C13.7775 12.312 13.5645 12.5 13.3125 12.5H11.5V19.875C16.303 19.1475 20 15.003 20 10C20 4.486 15.514 0 10 0Z"
                    fill="#2A5CA4"
                  />
                </svg>
                {{ $t("pages.social_login_btns.facebook") }}
              </button>
            </div>

            <div class="form-group">
              <button
                class="
                  flex
                  items-center
                  justify-start
                  rounded-lg
                  w-full
                  btn_google
                "
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.5 8.75V11.25C9.5 11.664 9.8355 12 10.25 12H15.6545C15.405 12.708 15.0265 13.349 14.552 13.9025L17.5685 16.517C19.0795 14.7645 20 12.49 20 10C20 9.586 19.968 9.156 19.899 8.649C19.8485 8.2775 19.531 8 19.156 8H10.25C9.8355 8 9.5 8.336 9.5 8.75ZM4.306 11.8805C4.11 11.2885 4 10.657 4 10C4 9.343 4.11 8.7115 4.306 8.1195L1.0275 5.6125C0.376 6.939 0 8.4245 0 10C0 11.5755 0.376 13.061 1.028 14.3875L4.306 11.8805ZM13.4325 14.9175C12.453 15.602 11.266 16 10 16C7.894 16 6.0415 14.907 4.9705 13.261L1.7895 15.6935C3.5975 18.2925 6.601 20 10 20C12.484 20 14.754 19.084 16.5045 17.58L13.4325 14.9175ZM16.7575 2.6485C14.9065 0.9405 12.5065 0 10 0C6.601 0 3.5975 1.7075 1.7895 4.307L4.9705 6.7395C6.0415 5.093 7.894 4 10 4C11.472 4 12.888 4.5405 13.987 5.5215C14.2835 5.7865 14.736 5.7735 15.017 5.492L16.7795 3.73C16.924 3.586 17.003 3.3885 16.999 3.1845C16.995 2.9805 16.9075 2.787 16.7575 2.6485Z"
                    fill="#F3423D"
                  />
                </svg>
                {{ $t("pages.social_login_btns.google") }}
              </button>
            </div>

            <div class="form-group mt-44">
              <label
                class="
                  text text-info text-info1
                  flex
                  items-center
                  justify-center
                "
                @click="$router.push({ name: 'RequestInformation' })"
              >
                <span class="icon">
                  <svg
                    width="20"
                    height="19"
                    viewBox="0 0 20 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.5 0.5C3.5625 0.5 2.76441 0.878567 2.25195 1.45508C1.7395 2.03159 1.5 2.77083 1.5 3.5C1.5 4.22917 1.7395 4.96841 2.25195 5.54492C2.76441 6.12143 3.5625 6.5 4.5 6.5C5.4375 6.5 6.23559 6.12143 6.74805 5.54492C7.2605 4.96841 7.5 4.22917 7.5 3.5C7.5 2.77083 7.2605 2.03159 6.74805 1.45508C6.23559 0.878567 5.4375 0.5 4.5 0.5ZM15.5 0.5C14.5625 0.5 13.7644 0.878567 13.252 1.45508C12.7395 2.03159 12.5 2.77083 12.5 3.5C12.5 4.22917 12.7395 4.96841 13.252 5.54492C13.7644 6.12143 14.5625 6.5 15.5 6.5C16.4375 6.5 17.2356 6.12143 17.748 5.54492C18.2605 4.96841 18.5 4.22917 18.5 3.5C18.5 2.77083 18.2605 2.03159 17.748 1.45508C17.2356 0.878567 16.4375 0.5 15.5 0.5ZM4.5 2C5.0625 2 5.38941 2.18393 5.62695 2.45117C5.8645 2.71841 6 3.10417 6 3.5C6 3.89583 5.8645 4.28159 5.62695 4.54883C5.38941 4.81607 5.0625 5 4.5 5C3.9375 5 3.61059 4.81607 3.37305 4.54883C3.1355 4.28159 3 3.89583 3 3.5C3 3.10417 3.1355 2.71841 3.37305 2.45117C3.61059 2.18393 3.9375 2 4.5 2ZM15.5 2C16.0625 2 16.3894 2.18393 16.627 2.45117C16.8645 2.71841 17 3.10417 17 3.5C17 3.89583 16.8645 4.28159 16.627 4.54883C16.3894 4.81607 16.0625 5 15.5 5C14.9375 5 14.6106 4.81607 14.373 4.54883C14.1355 4.28159 14 3.89583 14 3.5C14 3.10417 14.1355 2.71841 14.373 2.45117C14.6106 2.18393 14.9375 2 15.5 2ZM10 5.5C9.0625 5.5 8.26441 5.87857 7.75195 6.45508C7.2395 7.03159 7 7.77083 7 8.5C7 9.22917 7.2395 9.96841 7.75195 10.5449C8.26441 11.1214 9.0625 11.5 10 11.5C10.9375 11.5 11.7356 11.1214 12.248 10.5449C12.7605 9.96841 13 9.22917 13 8.5C13 7.77083 12.7605 7.03159 12.248 6.45508C11.7356 5.87857 10.9375 5.5 10 5.5ZM10 7C10.5625 7 10.8894 7.18393 11.127 7.45117C11.3645 7.71841 11.5 8.10417 11.5 8.5C11.5 8.89583 11.3645 9.28159 11.127 9.54883C10.8894 9.81607 10.5625 10 10 10C9.4375 10 9.11059 9.81607 8.87305 9.54883C8.6355 9.28159 8.5 8.89583 8.5 8.5C8.5 8.10417 8.6355 7.71841 8.87305 7.45117C9.11059 7.18393 9.4375 7 10 7ZM1.75 7.5C0.785 7.5 0 8.285 0 9.25V10.5C0 12.18 1.975 13.5 4.5 13.5H4.60547C4.83047 12.695 5.41969 12.0398 6.17969 11.7148C5.70469 11.8898 5.13 12 4.5 12C2.785 12 1.5 11.21 1.5 10.5V9.25C1.5 9.11 1.61 9 1.75 9H6.03027C6.01027 8.835 6 8.67 6 8.5C6 8.155 6.045 7.82 6.125 7.5H1.75ZM13.875 7.5C13.955 7.82 14 8.155 14 8.5C14 8.67 13.9897 8.835 13.9697 9H18.25C18.39 9 18.5 9.11 18.5 9.25V10.5C18.5 11.21 17.215 12 15.5 12C14.87 12 14.2953 11.8898 13.8203 11.7148C14.5803 12.0398 15.1695 12.695 15.3945 13.5H15.5C18.025 13.5 20 12.18 20 10.5V9.25C20 8.285 19.215 7.5 18.25 7.5H13.875ZM7.25 12.5C6.29252 12.5 5.5 13.2925 5.5 14.25V15.5C5.5 16.4591 6.13996 17.2406 6.96289 17.7344C7.78582 18.2281 8.84288 18.5 10 18.5C11.1571 18.5 12.2142 18.2281 13.0371 17.7344C13.86 17.2406 14.5 16.4591 14.5 15.5V14.25C14.5 13.2925 13.7075 12.5 12.75 12.5H7.25ZM7.25 14H12.75C12.8975 14 13 14.1025 13 14.25V15.5C13 15.7834 12.7999 16.1276 12.2656 16.4482C11.7313 16.7688 10.9139 17 10 17C9.08612 17 8.26869 16.7688 7.73438 16.4482C7.20006 16.1276 7 15.7834 7 15.5V14.25C7 14.1025 7.10248 14 7.25 14Z"
                      fill="#63B15B"
                    />
                  </svg>
                </span>
                {{ $t("pages.common.links.help") }}
              </label>
            </div>
          </div>
          <!-- End -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner";
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
export default {
  name: "ConfirmCellPhone",
  components: { LoadingSpinner, VueTelInput },
  data() {
    return {
      cell: "",
      country: null,
      checkednumbers: "",

      bindProps: {
        defaultCountry: "pl",
        mode: "international",
        onlyCountries: [
          "be",
          "bg",
          "cm",
          "cr",
          "hr",
          "cu",
          "cz",
          "dk",
          "ec",
          "ee",
          "et",
          "fi",
          "fr",
          "gf",
          "pf",
          "ga",
          "ge",
          "de",
          "hu",
          "is",
          // "in",
          "ie",
          "it",
          "ma",
          "nl",
          "no",
          "py",
          "pe",
          "pl",
          "pt",
          "rs",
          "es",
          "sz",
          "se",
          "ch",
          "tr",
          "gb",
        ],
      },
      options: { placeholder: this.$t("pages.common.buttons.dis91") },
    };
  },
  methods: {
    submit() {
      this.checkednumbers = ["7471112426", "9340014930"].includes(
        this.checkednumbers
      )
        ? "+91-" + this.checkednumbers
        : this.country + "-" + this.checkednumbers;
      this.$store
        .dispatch("user/verifyPhone", this.checkednumbers)
        .then((res) => {
          this.$router.push({
            name: res ? "confirmOtp" : "checkLastnameFailed",
          });
        });
    },
    countryChanged(country) {
      this.country = "+" + country.dialCode;
    },
    onInput(value) {},
    acceptNumber() {
      let sam = this.cell;
      this.checkednumbers = sam.replace(/[^\d]/g, "");
    },
    onlyNumber($event) {
      //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;

      // only allow number and one dot
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }

      if (this.cell.length >= 11) {
        $event.preventDefault();
      }
      if (this.cell.length >= 1) {
        let element = document.getElementById("phnumber");
        element.classList.add("active");
      }
      if (this.cell.length <= 0) {
        let element = document.getElementById("phnumber");
        element.classList.remove("reactive");
      }
    },
  },
};
</script>

<!--<style src="vue-tel-input/dist/vue-tel-input.css"></style>-->
<style scoped>
.active {
  border-color: #63b15b !important;
}
.bg-green-500 {
  background: #63b15b;
}
.otpmsg-block {
  color: #63b15b;
}
.bg-green-200 {
  background: #e6f7e3;
}

.sign_confirm_block {
  display: block;
  position: relative;
  margin: 30px 0 0;
}

.sign_confirm_block h4 {
  font-size: 22px;
  text-align: center;
  width: 100%;
  color: #333333;
  font-weight: bold;
  margin: 0 0 12px;
}

.sign_confirm_block p {
  color: #676666;
  text-align: center;
  font-size: 18px;
  font-weight: normal;
  font-weight: 500;
  margin: 0 0 12px;
}

.sign_confirm_block .input-group {
  width: 100%;
  border-radius: 4px;
  padding: 0;
  height: 46px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 1px solid #c6c6d1;
  margin: 0 0 16px;
}

.input-group .input-group-adddon {
  width: 15%;
  border-right: 1px solid #c6c6d1;
  color: #c6c6d1;
  font-weight: 500;
}

.input-group .form-control {
  width: 85%;
  padding-left: 10px;
  color: #c6c6d1;
  border-radius: 8px;
  background: transparent !important;
  outline: none !important;
  box-shadow: none !important;
  border: 0 !important;
  font-size: 14px;
  font-weight: 500;
}

.sign_confirm_block .input-group.active {
  /*border-color: #63b15b !important;*/
}
.sign_confirm_block .input-group.active .input-group-adddon {
  color: #333;
}
.sign_confirm_block .input-group.active .form-control {
  color: #333;
}

.sign_confirm_block .action_block {
  display: block;
}

.sign_confirm_block .action_block .btn_konto {
  border-color: #63b15b !important;
  color: #63b15b !important;
  background: transparent !important;
  margin: 15px 0 0;
}
.text-black {
  color: black !important;
}
.social_signup_block {
  display: block;
  position: relative;
}

.social_signup_block .or_option {
  border-bottom: 2px solid #c6c6d1;
  display: block;
  text-align: center;
  line-height: 0;
  margin: 0 0 20px;
}

.social_signup_block .or_option span {
  background: white;
  padding: 3px 12px;
}

.social_signup_block .form-group {
  display: block;
  margin: 0 0 15px;
}

.social_signup_block .form-group button {
  background: #f7f7f7;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  padding: 12px 14px;
  height: 46px;
  border-radius: 6px;
}

.social_signup_block .form-group .btn_facebook {
  color: #2a5ca4;
}

.social_signup_block .form-group button svg {
  width: 22px;
  height: 22px;
  margin-right: 13px;
}

.social_signup_block .form-group .btn_google {
  color: #f3423d;
}

.social_signup_block .form-group .text-info {
  text-align: center;
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: #63b15b !important;
}

.social_signup_block .form-group .text-info a {
  color: #63b15b !important;
}

.social_signup_block .form-group .text-info .icon {
  margin-right: 8px;
}

.social_signup_block .form-group .text-info {
  margin-top: 30px;
}

.social_signup_block .form-group svg {
  display: inline;
}
.mt-44 {
  margin-top: 11rem !important;
}
/*-----------------------  Responsive code ------------------*/
/*-----------------------  Responsive code ------------------*/
@media only screen and (max-width: 767px) {
  .sign_confirm_block h4 {
    font-size: 17px;
  }
  .sign_confirm_block p {
    font-size: 13px;
  }
}

/*-----------------------  Responsive code ------------------*/
/*-----------------------  Responsive code ------------------*/
</style>
